import posthog from "posthog-js";

let ph: typeof posthog | null = null;

export function initAnalytics(projectKey: string, host: string) {
  if (typeof window === "undefined") return;
  if (ph) return;

  posthog.init(projectKey, {
    api_host: host,
    capture_pageview: false, // we track pageviews manually on route change
    disable_session_recording: false,
  });
  ph = posthog;
}

export function getAnalytics() {
  if (!ph) throw new Error("Analytics not initialized. Call initAnalytics first.");
  return ph;
}

export function track(event: string, properties?: Record<string, unknown>) {
  ph?.capture(event, properties);
}

export function identify(userId: string, properties?: Record<string, unknown>) {
  ph?.identify(userId, properties);
}

export function pageview(path: string) {
  ph?.capture("$pageview", { $current_url: path });
}
